<template lang="pug">
    .b-cards
        .splide(ref="splide")
            .splide__track
                .splide__list
                    .splide__slide(v-for="(cardRegistration, index) in cardRegistrations" :key="index")
                        .b-cards__card(:class="[`slide-${(index % 3) + 1}`]")
                            .b-cards__card-icon
                                img(:src="`/images/client/got-me-hookd/payment-card-type-${cardRegistration.card_brand.toLowerCase()}.svg`" :alt="cardRegistration.brand_name")
                            .b-cards__card-number
                                .b-cards__card-number-section.b-cards__card-number-section--dots(v-for="i in 3") ••••
                                .b-cards__card-number-section {{ cardRegistration.card_last4 }}
                            .b-cards__card-footer
                                .b-cards__card-holder
                                    label Card Holder
                                    div {{ cardRegistration.card_holder }}
                                .b-cards__card-expires
                                    label Expires
                                    div {{ cardRegistration.card_expiry_month }}/{{ cardRegistration.card_expiry_year }}
        
        resize-sensor(@resize="onResize")

</template>

<script>
import Splide from '@splidejs/splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

export default {
    name: 'payment-methods',

    props: {
        cardRegistrations: {
            type: Array,
            required: true
        },
        start: {
            type: Number,
            default: 0,
        }
    },

    data() { return {
        splide: null,
        visible: false,
    }},

    methods: {
        onResize(e) {
            if (this.visible) {
                return
            }

            if (e.width || e.height) {
                this.visible = true
                this.splide.refresh()
            }
        },
    },

    mounted() {
        if (this.$refs.splide) {
            const splide = new Splide(this.$refs.splide, {
                type: 'loop',
                perPage: 3,
                autoWidth: true,
                perMove: 1,
                focus: 'center',
                arrows: false,
                rewind: true,
                gap: 20,
                pagination: true,
                start: this.start,
            }).mount()

            const that = this
            splide.on('moved', function(index) {
                that.$emit('select', index)
            })

            splide.on('click', function(slide) {
                splide.go(slide.index)
            })

            this.splide = splide
        }
    }
}
</script>
